var map = {
	"./btcb.svg": 10530,
	"./busd.svg": 52213,
	"./cake.svg": 64179,
	"./eth.svg": 5340,
	"./usdcIcon.svg": 12887,
	"./usdt.svg": 5763,
	"./wbnb.svg": 9148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40289;